'use client';

import { c as _c } from "react/compiler-runtime";
import { useRouter } from 'next/navigation';
import { Box, Button } from '@/components';
export function PageOverLimit() {
  const $ = _c(3);
  const router = useRouter();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p className="m-0 pb-6 text-lg">We can only show top 10,000 results. Please refine your search criteria.</p>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== router) {
    t1 = <Box className="mt-6 font-medium"><section className="text-center" aria-live="polite">{t0}<Button type="button" onClick={() => router.back()}>Go Back</Button></section></Box>;
    $[1] = router;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}